import { GetAccountAppMetricsPerWorkspaceSummaryApplicationService } from '../../../../src/core/application/services/top-apps/get-account-app-metrics-per-workspace-summary.application-service';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountAppMetricsPerWorkspaceSummaryRequestDto } from '../../../../src/interface/dtos/top-apps/get-account-app-metrics-per-workspace-summary.request.dto';
import { AccountAppMetricsPerWorkspaceSummaryAggregateRoot } from '../../../../src/core/domain/aggregates/top-apps/account-app-metrics-per-workspace-summary.aggregate-root';

export class GetAccountAppMetricsPerWorkspaceSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetAccountAppMetricsPerWorkspaceSummaryApplicationService
  ) {}

  async execute(
    props: GetAccountAppMetricsPerWorkspaceSummaryRequestDto
  ): Promise<AccountAppMetricsPerWorkspaceSummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new Error(
        `GetAccountAppMetricsPerWorkspaceSummaryQuery.execute encountered an error ${error}`
      );
    }
  }
}
